import { ApolloError } from '@apollo/client';

export const SSO_REQUIRED_CODE = 'SSO_REQUIRED';

export const SSO_REQUIRED_MESSAGE =
  'Password authentication is disabled for this account. Please sign in with Okta SSO.';

/** Reads the `extensions.code` off the first GraphQL error, if the failure carries one. */
export function getGraphQLErrorCode(error: unknown): string | undefined {
  const graphQLErrors = (error as ApolloError | undefined)?.graphQLErrors;
  const code = graphQLErrors?.[0]?.extensions?.code;
  return typeof code === 'string' ? code : undefined;
}

/** Distinguishes "must use SSO" from a genuine credential failure, so the UI can point to Okta. */
export function isSsoRequiredError(error: unknown): boolean {
  return getGraphQLErrorCode(error) === SSO_REQUIRED_CODE;
}
